import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import '../pages/TeklifFaturaPDF.css';

const TeklifFaturaPDF = ({ teklif }) => {
  const handlePdfOlustur = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('TEKLİF / FATURA', 14, 20);

    doc.setFontSize(12);
    doc.text(`Firma: ${teklif.firma}`, 14, 30);
    doc.text(`Tarih: ${new Date().toLocaleDateString()}`, 14, 36);

    const parcalar = teklif.parcalar || {};
    const rows = [];

    Object.entries(parcalar).forEach(([parcaTuru, tedarikciler]) => {
      tedarikciler.forEach((ted, index) => {
        rows.push([
          parcaTuru,
          ted.adi || '',
          ted.kod || '',
          ted.fiyat || '',
        ]);
      });
    });

    doc.autoTable({
      startY: 50,
      head: [['Parça Türü', 'Tedarikçi', 'Kod', 'Fiyat']],
      body: rows,
    });

    doc.save(`Teklif_${teklif.firma}.pdf`);
  };

  return (
    <button className="pdf-button" onClick={handlePdfOlustur}>
      📄 PDF Oluştur
    </button>
  );
};

export default TeklifFaturaPDF;
